import PropTypes from 'prop-types';
import { CloudinaryPicture, GridBleed } from '@bwoty-web/ui-kit';

import RouteContent from '../cruiseDescription/routeContent';

import './cruiseRouteDescriptionView.scss';

const CruiseRouteDescriptionView = ({
  cruiseContent: { itinerary = [], shipContent, routeMapImage },
  labels,
}) => {
  return (
    <div className="gw-cruise-route-description-container">
      {routeMapImage && (
        <GridBleed variant="full-mobile">
          <CloudinaryPicture
            alt={routeMapImage.alt}
            className="gw-cruise-route-description__route-image"
            img={routeMapImage}
            retina
            sizes={routeMapImage.sizes}
          />
        </GridBleed>
      )}
      <RouteContent
        atSeaText={shipContent?.atSeaText}
        itinerary={itinerary}
        labels={labels}
      />
    </div>
  );
};

CruiseRouteDescriptionView.propTypes = {
  cruiseContent: PropTypes.shape({
    itinerary: PropTypes.arrayOf(PropTypes.shape({})),
    routeMapImage: PropTypes.shape({
      sizes: PropTypes.arrayOf(PropTypes.shape({})),
      alt: PropTypes.string,
    }).isRequired,
    shipContent: PropTypes.shape({ atSeaText: PropTypes.string }).isRequired,
  }).isRequired,
  labels: PropTypes.shape({}).isRequired,
};

export default CruiseRouteDescriptionView;
